import { Select } from 'antd5';
import { sortBy } from 'lodash';
import { type BaseSelectRef } from 'rc-select';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { filterOption } from 'components/choosers/helpers';
import {
  CustomFilterContainer,
  CustomFilterPopover,
  SelectContainer,
} from 'components/data/helpers/filters.style';
import { Button } from 'components/ui';
import { AutoFocus } from 'horizon/components/AutoFocus';
import { type CustomFilterDropdownProps } from 'horizon/types/TableColumnDef';
import { useGetSitesMinimalQuery } from 'types/atlas-graphql';

export const SiteFilter: React.FunctionComponent<CustomFilterDropdownProps> = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
}) => {
  const { t } = useTranslation();
  const inputRef = useRef<BaseSelectRef>(null);
  const siteIds = selectedKeys || [];

  const { data: sitesData, loading: sitesLoading } = useGetSitesMinimalQuery();
  const sites = sortBy(sitesData?.sites?.items, ['name']) ?? [];

  const handleChange = (value: string[]) => {
    setSelectedKeys(value);
  };

  const handleConfirm = () => {
    confirm({ closeDropdown: true });
  };

  const handleReset = () => {
    clearFilters && clearFilters();
  };

  return (
    <AutoFocus elementToFocus={inputRef}>
      <CustomFilterPopover className="ant-table-filter-dropdown">
        <CustomFilterContainer>
          <SelectContainer style={{ paddingRight: '44px', width: '240px' }}>
            <Select
              id="site-filter-dropdown"
              ref={inputRef}
              placeholder={t('table.selectSite', 'Select Site...')}
              loading={sitesLoading}
              allowClear={true}
              showSearch={true}
              filterOption={filterOption}
              virtual={false}
              value={sitesLoading ? undefined : siteIds}
              onChange={handleChange}
              mode={'multiple'}
            >
              {sites.map(site => (
                <Select.Option key={site.id} className="site-filter-option" value={site.id}>
                  {site.name}
                </Select.Option>
              ))}
            </Select>
          </SelectContainer>
        </CustomFilterContainer>
        <div className="ant-table-filter-dropdown-btns" style={{ borderTop: '1px solid #f0f0f0' }}>
          <Button type="link" size="small" onClick={handleReset}>
            {t('table.reset', 'Reset')}
          </Button>
          <Button type="primary" size="small" onClick={handleConfirm}>
            {t('table.ok', 'OK')}
          </Button>
        </div>
      </CustomFilterPopover>
    </AutoFocus>
  );
};
